export enum BotExchange
{
  coinbase = "Coinbase",
  kraken = "Kraken",
  binance = "Binance",
  binanceUS = "Binance.US",
  binanceTestnet = "Binance TestNet",
  gateIo = "Gate IO",
}
